module.exports = __webpack_public_path__ + "static/media/06.3ffeab99.png";